module.exports = __webpack_public_path__ + "img/beneficios-04.914b82a1.png";